/**
 * Created by mongoose on 14/11/17.
 */
import React from "react";
import PropTypes from "prop-types";
import { FormControl, FormGroup } from "react-bootstrap-3";

function handleOnChange({ onChange, event, oldValue, attribute, field }) {
  let newValue = event && event.target && event.target.value;

  const value = {
    ...oldValue,
    [attribute]: newValue,
  };

  onChange({ event, value, field: field.fieldName });
}

function DurationGroup({ value, hasErrors, onChange, field, disabled }) {
  const { fieldName, placeholder, optionDisplay } = field;
  const { duration, chronoUnit } = value;
  return (
    <div>
      <div className="row">
        <FormGroup bsClass="col-md-6">
          <FormControl
            value={duration}
            type="text"
            placeholder={placeholder}
            disabled={disabled}
            className={`form-control ${hasErrors && "parsley-error"}`}
            onChange={event =>
              handleOnChange({
                onChange,
                oldValue: value,
                attribute: "duration",
                event,
                field,
              })
            }
          />
        </FormGroup>
        <FormGroup bsClass="col-md-6">
          <label style={{ visibility: "hidden" }}>_</label>
          <FormControl
            value={chronoUnit}
            name={fieldName}
            componentClass="select"
            className={`form-control ${hasErrors && "parsley-error"}`}
            onChange={event =>
              handleOnChange({
                onChange,
                oldValue: value,
                attribute: "chronoUnit",
                event,
                field,
              })
            }>
            {Object.keys(optionDisplay).map(key => (
              <option value={key} key={key}>
                {optionDisplay[key].label}
              </option>
            ))}
          </FormControl>
        </FormGroup>
      </div>
    </div>
  );
}

DurationGroup.propTypes = {
  field: PropTypes.object,
  formErrors: PropTypes.object,
  formValues: PropTypes.object,
  hasErrors: PropTypes.bool,
  onChange: PropTypes.func,
};

export default DurationGroup;
